/**
 * AI.GEN lines=1-26
 * 域名 Cookie 工具
 */
import { getRootDomain } from '@hpfe/common-base';
import Cookies, { CookieAttributes } from 'js-cookie';

const domain = getRootDomain(window.location.hostname);

const cookieOptions: CookieAttributes = {
  domain,
  path: '/',
};

/**
 * 域名 Cookie 操作对象
 */
export const domainCookie = {
  /**
   * 设置 Cookie
   * @param key Cookie 键
   * @param value Cookie 值
   */
  set(key: string, value: string): void {
    Cookies.set(key, value, {
      ...cookieOptions,
    });
  },

  /**
   * 获取 Cookie
   * @param key Cookie 键
   * @returns Cookie 值
   */
  get(key: string): string | undefined {
    return Cookies.get(key);
  },

  /**
   * 删除 Cookie
   * @param key Cookie 键
   */
  remove(key: string): void {
    Cookies.remove(key, {
      ...cookieOptions,
    });
  },
};
